import LoaderGif from '../assets/img/loder.gif';

const CircleLoader = () => {
    return (<img className="pageloader-mainpage" src={LoaderGif} />)
}

export default CircleLoader